import { isString, toLocalID, uuid } from 'src/shared/helpers';
import { Side } from '../side';
import { ModelSide, createDefaultModelSide } from './modelSide';

/**
 * Model Color
 * @param colorID The color ID
 * @param name The color name
 * @param code The color code in JSON format
 * @param sides The model sides list
 * @param guid a temp guid used during the configuration, just use uuid() as value
 */
export interface ModelColor {
    colorID: number | null;
    name: string;
    code: string;
    colorProviderCode: string | null;
    position: number;
    guid: string;
    sides: ModelSide[];
}

export interface ProductColor {
    code: string | null;
    colorCode: string | null;
    colorID: number;
    name: string;
    guid: string;
}

// Sample color for products without variations
export const createDefaultModelColor = (baseSide?: Side) => {
    const modelColor: ModelColor = {
        colorID: 1,
        name: 'Sample color',
        code: '[]',
        colorProviderCode: null,
        guid: uuid(),
        position: 0,
        sides: []
    };

    if (baseSide) modelColor.sides.push(createDefaultModelSide(baseSide));

    return modelColor;
};

// Return true if modelColor is the default color (Sample Color)
export const isDefaultColor = (modelColor: { colorID: string | number | null }) => {
    let colorID = modelColor.colorID;

    if (colorID && isString(colorID)) colorID = toLocalID(colorID);

    return colorID == 1;
};
